export const south_dakota = {
  "46000": "South Dakota",
  "46003": "Aurora County",
  "46005": "Beadle County",
  "46007": "Bennett County",
  "46009": "Bon Homme County",
  "46011": "Brookings County",
  "46013": "Brown County",
  "46015": "Brule County",
  "46017": "Buffalo County",
  "46019": "Butte County",
  "46021": "Campbell County",
  "46023": "Charles Mix County",
  "46025": "Clark County",
  "46027": "Clay County",
  "46029": "Codington County",
  "46031": "Corson County",
  "46033": "Custer County",
  "46035": "Davison County",
  "46037": "Day County",
  "46039": "Deuel County",
  "46041": "Dewey County",
  "46043": "Douglas County",
  "46045": "Edmunds County",
  "46047": "Fall River County",
  "46049": "Faulk County",
  "46051": "Grant County",
  "46053": "Gregory County",
  "46055": "Haakon County",
  "46057": "Hamlin County",
  "46059": "Hand County",
  "46061": "Hanson County",
  "46063": "Harding County",
  "46065": "Hughes County",
  "46067": "Hutchinson County",
  "46069": "Hyde County",
  "46071": "Jackson County",
  "46073": "Jerauld County",
  "46075": "Jones County",
  "46077": "Kingsbury County",
  "46079": "Lake County",
  "46081": "Lawrence County",
  "46083": "Lincoln County",
  "46085": "Lyman County",
  "46087": "McCook County",
  "46089": "McPherson County",
  "46091": "Marshall County",
  "46093": "Meade County",
  "46095": "Mellette County",
  "46097": "Miner County",
  "46099": "Minnehaha County",
  "46101": "Moody County",
  "46103": "Pennington County",
  "46105": "Perkins County",
  "46107": "Potter County",
  "46109": "Roberts County",
  "46111": "Sanborn County",
  "46113": "Shannon County",
  "46115": "Spink County",
  "46117": "Stanley County",
  "46119": "Sully County",
  "46121": "Todd County",
  "46123": "Tripp County",
  "46125": "Turner County",
  "46127": "Union County",
  "46129": "Walworth County",
  "46135": "Yankton County",
  "46137": "Ziebach County",
};
